import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesGrid from './components/ServicesGrid';
import TestimonialSection from './components/TestimonialSection';
import FeaturesShowcase from './components/FeaturesShowcase';
import CTASection from './components/CTASection';
import SeoHead from '../../components/feature/SeoHead';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'VORENN TECH',
    url: SITE_URL,
    logo: `${SITE_URL}/favicon.png`,
    description: 'VORENN TECH delivers expert IT consulting, cloud migration, business support, advertisement & marketing, and SMM management services tailored to your business needs.',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer support',
      availableLanguage: 'English',
    },
    sameAs: [],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'VORENN TECH',
    url: SITE_URL,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${SITE_URL}/shop?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'VORENN TECH IT Services',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'IT Consulting', url: `${SITE_URL}/service/it-consulting` },
      { '@type': 'ListItem', position: 2, name: 'Cloud Migration', url: `${SITE_URL}/service/cloud-migration` },
      { '@type': 'ListItem', position: 3, name: 'Business Support Services', url: `${SITE_URL}/service/business-support-services` },
      { '@type': 'ListItem', position: 4, name: 'Advertisement & Marketing Services', url: `${SITE_URL}/service/advertisement-marketing-services` },
      { '@type': 'ListItem', position: 5, name: 'SMM Management Services', url: `${SITE_URL}/service/smm-management-services` },
    ],
  },
];

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="VORENN TECH - IT Consulting, Cloud Migration & Business Support Services"
        description="VORENN TECH delivers expert IT consulting, cloud migration, business support, advertisement & marketing, and SMM management services. Professional IT solutions from $299–$599, tailored to your business needs."
        keywords="VORENN TECH, IT consulting, cloud migration, business support services, advertisement marketing, SMM management"
        canonical="/"
        jsonLd={homeJsonLd}
      />
      <Navbar />
      <HeroSection />
      <ServicesGrid />
      <TestimonialSection />
      <FeaturesShowcase />
      <CTASection />
      <Footer />
    </div>
  );
};

export default HomePage;